"use client";
import { CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { Button } from "antd";
import React, { useState } from "react";

const BuyModal = ({
  isOpen,
  onClose,
  isBNPL,
  addProduct,
  handleInstallmentModal,
}) => {
  return (
    <>
      <Modal
        open={isOpen}
        onCancel={onClose}
        footer={null}
        centered
        closeIcon={<CloseOutlined style={{ color: "black" }} />}
        styles={{
          body: {
            display: "flex",
            flexDirection: "column",
            padding: "10px 5px",
            opacity: 1,
          },
        }}
        width={440}
      >
        <h2 style={{ textAlign: "left" }}>Select Payment Feature</h2>
        {isBNPL === "Yes" ? (
          <Button
            size="middle"
            className="buy-modal"
            style={{
              backgroundColor: "#333333",
              fontSize: "14px",
              marginBottom: "10px",
              color: "white",
              padding: "20px",
              width: "100%",
              borderRadius: "0",
              alignItems: "center",
              border: "none",
            }}
            onClick={handleInstallmentModal}
          >
            Buy Now, Pay Later
          </Button>
        ) : null}
        <Button
          onClick={() => {
            addProduct();
            onClose();
          }}
          size="large"
          className="paymentFeatureModal"
          style={{
            backgroundColor: "#333333",
            fontSize: "14px",
            width: "100%",
            padding: "20px",
            borderRadius: "0",
            alignItems: "center",
            color: "white",
            border: "none",
          }}
        >
          Pay in Full
        </Button>
      </Modal>
    </>
  );
};

export default BuyModal;
